import FallbackComponent from '@components/std-components/FallbackComponent'
import React, { lazy, Suspense } from 'react'

const OrigEnhancedWarningPopupContent = lazy(() =>
  import('./EnhancedWarningPopupContent').then(m => ({
    default: m.EnhancedWarningPopupContent
  }))
)

export const EnhancedWarningPopupContent = props => {
  return (
    <Suspense fallback={<FallbackComponent />}>
      <OrigEnhancedWarningPopupContent {...props} />
    </Suspense>
  )
}
